// determine if passed item is an Object and not an Array
// -- Arrays are also considered an Object in JS, but we want a "common" object

export default function isObject ( item ) {
    return item
        && typeof item === "object"
        && !Array.isArray( item )
}